import { render, staticRenderFns } from "./UndoIcon.vue?vue&type=template&id=68286d36"
import script from "./UndoIcon.vue?vue&type=script&lang=js"
export * from "./UndoIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports